import { Slider } from '../modules/slider';
import { TextPopup } from '../modules/textPopup';

const teamSections = document.querySelectorAll('.meet-teachers');

if (teamSections.length > 0) {
    const handlePopup = (card, popup) => {
        const title = card.querySelector('.card-team-member__title');
        const position = card.querySelector('.card-team-member__position');
        const image = card.querySelector('.card-team-member__image');
        const bio = card.querySelector('.card-team-member__bio');
        popup = new TextPopup({
            card: card,
            name: title.textContent || null,
            position: position.textContent || null,
            bio: bio.innerHTML || null,
            image:
                {
                    alt: image.alt,
                    title: image.title,
                    src: image.src,
                } || null,
        });
    };

    const handleBioClick = (cards, popup) => {
        if (!cards) return;
        cards.forEach(card => {
            const bioButton = card.querySelector(
                '.card-team-member__bio-button'
            );
            if (bioButton)
                bioButton.addEventListener('click', () =>
                    handlePopup(card, popup)
                );
        });
    };

    teamSections.forEach(section => {
        const cards = section.querySelectorAll('.meet-teachers__item');

        let popup = null;
        let slider = null;
        handleBioClick(cards, popup);
    });
}
